import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { HookSection } from './HookSection';
import { TruthSection } from './TruthSection';
import { MethodSection } from './MethodSection';
import { BenefitsSection } from './BenefitsSection';
import { ProductShowcase } from './ProductShowcase';
import { PriceSection } from './PriceSection';
import { FAQSection } from './FAQSection';
import { XIcon } from 'lucide-react';
export function SalesPage() {
  const [modal, setModal] = useState<'terms' | 'privacy' | null>(null);
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '1609417253435117');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-cream font-sans text-brown-primary selection:bg-rose-gold/30" data-id="element-115">
      {/* Navigation / Header Placeholder */}
      <nav className="w-full py-4 px-6 flex justify-center border-b border-brown-secondary/10 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-116">
        <span className="font-serif text-xl font-bold tracking-wider text-brown-primary" data-id="element-117">
          PIEL DE VIDRIO
        </span>
      </nav>

      <HeroSection data-id="element-118" />
      <HookSection data-id="element-119" />
      <TruthSection data-id="element-120" />
      <MethodSection data-id="element-121" />
      <BenefitsSection data-id="element-122" />
      <ProductShowcase data-id="element-123" />
      <FAQSection data-id="element-124" />
      <PriceSection data-id="element-125" />

      {/* Footer */}
      <footer className="bg-brown-primary text-cream/60 py-8 px-4 text-center text-sm" data-id="element-126">
        <div className="flex justify-center gap-6 mb-3" data-id="element-127">
          <button onClick={() => setModal('terms')} className="hover:text-cream transition-colors underline-offset-2 hover:underline" data-id="element-128">
            Términos y Condiciones
          </button>
          <button onClick={() => setModal('privacy')} className="hover:text-cream transition-colors underline-offset-2 hover:underline" data-id="element-129">
            Política de Privacidad
          </button>
        </div>
        <p data-id="element-130">&copy; 2026 Piel de Vidrio. Todos los derechos reservados.</p>
      </footer>

      {/* Modal */}
      {modal && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4" onClick={() => setModal(null)} data-id="element-131">
          <div className="bg-cream rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-132">
            <div className="sticky top-0 bg-cream border-b border-brown-secondary/10 flex items-center justify-between px-6 py-4 rounded-t-xl" data-id="element-133">
              <h3 className="font-serif text-xl font-bold text-brown-primary" data-id="element-134">
                {modal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h3>
              <button onClick={() => setModal(null)} className="p-1 rounded-full hover:bg-brown-secondary/10 transition-colors" data-id="element-135">
                <XIcon className="w-5 h-5 text-brown-secondary" data-id="element-136" />
              </button>
            </div>

            <div className="px-6 py-6 text-brown-secondary leading-relaxed space-y-4 text-sm" data-id="element-137">
              {modal === 'terms' ? <>
                  <p data-id="element-138">
                    <strong className="text-brown-primary" data-id="element-139">
                      1. Aceptación de los Términos
                    </strong>
                    <br data-id="element-140" />
                    Al adquirir y descargar la guía "Piel de Vidrio: Lujo de
                    Farmacia", aceptas estos términos y condiciones en su
                    totalidad.
                  </p>

                  <p data-id="element-141">
                    <strong className="text-brown-primary" data-id="element-142">
                      2. Producto Digital
                    </strong>
                    <br data-id="element-143" />
                    Este producto es una guía digital en formato PDF. Una vez
                    realizada la compra, recibirás acceso inmediato a la
                    descarga. Debido a la naturaleza digital del producto, no se
                    aceptan devoluciones.
                  </p>

                  <p data-id="element-144">
                    <strong className="text-brown-primary" data-id="element-145">
                      3. Uso Personal
                    </strong>
                    <br data-id="element-146" />
                    La guía es para uso personal y exclusivo del comprador.
                    Queda prohibida su reproducción, distribución o reventa sin
                    autorización expresa.
                  </p>

                  <p data-id="element-147">
                    <strong className="text-brown-primary" data-id="element-148">
                      4. Resultados
                    </strong>
                    <br data-id="element-149" />
                    Los resultados pueden variar según el tipo de piel y la
                    constancia en la aplicación del método. La guía no sustituye
                    el consejo de un dermatólogo profesional.
                  </p>

                  <p data-id="element-150">
                    <strong className="text-brown-primary" data-id="element-151">
                      5. Propiedad Intelectual
                    </strong>
                    <br data-id="element-152" />
                    Todo el contenido de la guía está protegido por derechos de
                    autor © 2026 Piel de Vidrio.
                  </p>
                </> : <>
                  <p data-id="element-153">
                    <strong className="text-brown-primary" data-id="element-154">
                      1. Información que Recopilamos
                    </strong>
                    <br data-id="element-155" />
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre y correo electrónico.
                  </p>

                  <p data-id="element-156">
                    <strong className="text-brown-primary" data-id="element-157">
                      2. Uso de la Información
                    </strong>
                    <br data-id="element-158" />
                    Tu información se utiliza exclusivamente para entregar el
                    producto digital y enviarte actualizaciones relacionadas con
                    tu compra.
                  </p>

                  <p data-id="element-159">
                    <strong className="text-brown-primary" data-id="element-160">
                      3. Protección de Datos
                    </strong>
                    <br data-id="element-161" />
                    No compartimos, vendemos ni cedemos tu información personal
                    a terceros bajo ninguna circunstancia.
                  </p>

                  <p data-id="element-162">
                    <strong className="text-brown-primary" data-id="element-163">4. Cookies</strong>
                    <br data-id="element-164" />
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación. Puedes desactivarlas en la
                    configuración de tu navegador.
                  </p>

                  <p data-id="element-165">
                    <strong className="text-brown-primary" data-id="element-166">5. Contacto</strong>
                    <br data-id="element-167" />
                    Para cualquier consulta sobre tu privacidad, puedes
                    comunicarte con nosotros a través de nuestros canales
                    oficiales.
                  </p>
                </>}
            </div>
          </div>
        </div>}
    </main>;
}